import { RiskLevel } from "../types/queries";
import { StyledSalesPermissionStatusIndicator } from "../styles";

interface Props {
  riskLevel?: RiskLevel;
  larger?: boolean;
}

const SalesPermissionStatusIndicator = ({ riskLevel, larger }: Props) => {
  const getIndicatorColor = (riskLevel?: RiskLevel) => {
    switch (riskLevel) {
      case RiskLevel.GREEN:
        return "success.main";
      case RiskLevel.YELLOW:
        return "info.main";
      case RiskLevel.RED:
        return "error.main";
      case RiskLevel.UNKNOWN:
        return "warning.main";
      default:
        return "";
    }
  };

  return (
    <StyledSalesPermissionStatusIndicator
      bgcolor={getIndicatorColor(riskLevel)}
      larger={larger}
    />
  );
};

export default SalesPermissionStatusIndicator;
